import { useState, useEffect } from 'react';

interface WorkflowFailure {
  message: string;
  type: string;
  retryable: boolean;
}

interface WorkflowRun {
  id: string;
  workflowId: string;
  status: string;
  startTime: string;
  endTime?: string;
  tasks: any[];
  workflowName: string;
  workflowPath: string;
  workflowInput?: any;
  workflowOutput?: any;
  workflowFailure?: WorkflowFailure;
  workflowDescription?: string;
  workflowFlowChart?: string;
  functionName: string;
}

const TERMINAL_STATUSES = ['completed', 'failed'];

export const useWorkflowRunPolling = (initialWorkflowRun: WorkflowRun) => {
  const [workflowRun, setWorkflowRun] = useState(initialWorkflowRun);

  useEffect(() => {
    if (!workflowRun.id) return;

    // Don't poll if workflow is in terminal state
    if (TERMINAL_STATUSES.includes(workflowRun.status)) return;

    const pollWorkflowRun = async () => {
      try {
        const response = await fetch(
          `/workflows/${workflowRun.workflowId}/runs/${workflowRun.id}.json`,
          { headers: { Accept: 'application/json' } }
        );
        const data = await response.json();
        setWorkflowRun(data);
      } catch {
        // Ignore polling errors
      }
    };

    // Poll immediately on mount for fresh data
    void pollWorkflowRun();

    // Then poll every 3 seconds for in-progress workflows
    const interval = setInterval(pollWorkflowRun, 3000);
    return () => clearInterval(interval);
  }, [workflowRun.id, workflowRun.workflowId, workflowRun.status]);

  return workflowRun;
};
